import { render, staticRenderFns } from "./sos-dialog.vue?vue&type=template&id=eb42c074&scoped=true&"
import script from "./sos-dialog.vue?vue&type=script&lang=js&"
export * from "./sos-dialog.vue?vue&type=script&lang=js&"
import style0 from "./sos-dialog.vue?vue&type=style&index=0&id=eb42c074&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb42c074",
  null
  
)

export default component.exports